'use client';

import { Checkbox, Description, Field, Label } from '@headlessui/react';
import { Ref, ReactNode, useState, useEffect } from 'react';

import { styles } from './UiKitCheckboxBase.styles';

export interface UiKitCheckboxBaseProps {
  className?: string;
  classNameInner?: string;
  classNameLabel?: string;
  checkboxClassName?: string;
  name?: string;
  label?: ReactNode;
  helperText?: string;
  error?: boolean;
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
  checked?: boolean;
  defaultChecked?: boolean;
  ref?: Ref<HTMLButtonElement>;
}

export function UiKitCheckboxBase({
  className,
  classNameInner,
  classNameLabel,
  checkboxClassName,
  label,
  helperText,
  error,
  disabled,
  onChange,
  ref,
  defaultChecked,
  ...props
}: UiKitCheckboxBaseProps) {
  const slots = styles({ error, disabled });

  const [checked, setChecked] = useState(
    Boolean(props.checked ?? defaultChecked)
  );

  useEffect(() => {
    setChecked(Boolean(props.checked ?? defaultChecked));
  }, [props.checked, defaultChecked]);

  const handleChange = (checked: boolean) => {
    setChecked(checked);
    onChange?.(checked);
  };

  return (
    <Field
      className={slots.base({ className })}
      disabled={disabled}
    >
      <div className={slots.checkboxContainer({ className: classNameInner })}>
        <Checkbox
          ref={ref}
          onChange={handleChange}
          className={slots.checkbox({ className: checkboxClassName })}
          checked={checked}
          {...props}
        >
          <svg
            width="12"
            height="9"
            viewBox="0 0 12 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={slots.icon()}
          >
            <path
              d="M11 1L4.125 8L1 4.81818"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Checkbox>
        {label && (
          <Label className={slots.label({ className: classNameLabel })}>
            {label}
          </Label>
        )}
      </div>
      {helperText && (
        <Description
          as="div"
          className={slots.helperText()}
        >
          {helperText}
        </Description>
      )}
    </Field>
  );
}
